<template>
    <div class="o-p-map">
        <ODMapController />
    </div>
</template>

<script>
import ODMapController from "../../organisms/o-d-map-controller/o-d-map-controller";

export default {
    name: "OPMap",
    components: {
        ODMapController
    }
}
</script>

<style lang="scss">
@import "o-p-map";
</style>
